/* eslint-disable react/destructuring-assignment,react/jsx-no-bind */
import React, { Component } from 'react';
import { connect } from 'dva';
import Copy from 'react-copy-to-clipboard';
import { Form, Row, Col, Radio, Button, message, Spin, Checkbox } from 'antd';
import ImgUpload from './imgUpload';
import { getAppCode, eduAppCode } from '../../utils/utils';
import Container from '../../../../../components/Container';
import styles from './index.less';

@connect(({ user }) => {
  return {
    orgType: user.currentUser.orgType,
  };
})
class WebSiteSetUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      spinning: false,
      data: {
        ispush: '',
        pushTime: '',
        channelids: '',
        isApproval: '',
        isAudit: '',
        pushIsAudit: '',
      },
    };
  }

  componentDidMount() {
    this.handleInitPushSetting();
  }

  handleInitPushSetting = () => {
    this.setState({ spinning: true });
    this.props
      .dispatch({
        type: 'webSiteSetUp/fetchPushConfigInfo',
        params: {
          appCode: getAppCode(),
        },
      })
      .then(res => {
        this.setState(
          {
            data: res,
            spinning: false,
          },
          () => {
            this.handleInitApprovalSetting();
          }
        );
      })
      .catch(() => {
        this.setState({
          spinning: false,
        });
      });
  };

  // 获取审批设置的配置
  handleInitApprovalSetting = () => {
    const { data } = this.state;
    this.setState({ spinning: true });
    this.props
      .dispatch({
        type: 'webSiteSetUp/fetchApprovalConfigInfo',
        params: {
          appCode: getAppCode(),
        },
      })
      .then(res => {
        this.setState({
          data: { ...data, ...res },
          spinning: false,
        });
      })
      .catch(() => {
        this.setState({
          spinning: false,
        });
      });
  };

  handlePushSettingSave = () => {
    const { dispatch } = this.props;
    const { data } = this.state;
    this.setState({ spinning: true });
    dispatch({
      type: 'webSiteSetUp/fetchMicrositeConfigSave',
      params: data,
    })
      .then(() => {
        dispatch({
          type: 'webSiteSetUp/fetchApprovalConfigSave',
          params: {
            ...data,
            appCode: getAppCode(),
          },
        }).then(() => {
          message.success('修改成功！');
          this.handleInitPushSetting();
        });
      })
      .catch(() => {
        this.setState({ spinning: false });
      });
  };

  handleTimePickerChange = (timeObject, pushTime) => {
    const { data } = this.state;
    this.setState({
      data: { ...data, pushTime },
    });
  };

  handleFormSubmit = e => {
    e.preventDefault();
    const { form } = this.props;
    const me = this;
    const { data } = this.state;
    form.validateFields((err, fieldsValue) => {
      if (!err) {
        const { channelids, news } = fieldsValue;
        me.setState(
          {
            data: {
              ...data,
              channelids,
              iswatermark: false,
              showRegionSelf: news?.indexOf('1') !== -1 ? 1 : 0,
              showRegionDirectly: news?.indexOf('2') !== -1 ? 1 : 0,
            },
          },
          () => {
            me.handlePushSettingSave();
          }
        );
      }
      form.resetFields();
    });
  };

  handleRadioChange = (event, type) => {
    const { data } = this.state;
    this.setState({
      data: {
        ...data,
        [type]: event.target.value,
      },
    });
  };

  handleUploadCallback = usercode => {
    const { data } = this.state;
    this.setState({
      data: { ...data, usercode },
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { orgType } = this.props;
    const formItemLayout = {
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
    };
    const footerProps = {
      states: true,
      demFooter: (
        <Button type="primary" onClick={e => this.handleFormSubmit(e)}>
          保存
        </Button>
      ),
    };

    const radioStyle = {
      display: 'block',
      height: '30px',
      lineHeight: '30px',
      top: orgType === 'county' ? '-5px' : 0,
    };

    const {
      iscustom,
      micrositeurl,
      usercode,
      isAudit,
      pushIsAudit,
      showRegionSelf = 1,
      showRegionDirectly = 1,
    } = this.state.data || {};
    const { spinning } = this.state;

    const defaultArr = [];
    if (showRegionSelf === 1) {
      defaultArr.push('1');
    }
    if (showRegionDirectly === 1) {
      defaultArr.push('2');
    }

    return (
      <Container breStates={!0} version={2} footerParams={footerProps}>
        <div className={styles.root}>
          <Spin spinning={spinning}>
            <Form className="site-set-up-form" {...formItemLayout}>
              <Row>
                <Col span={24}>
                  <Form.Item
                    colon={!1}
                    {...formItemLayout}
                    label="基本资料"
                    className="basic-info"
                  />
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Form.Item {...formItemLayout} cl label="微官网地址" className="address">
                    {getFieldDecorator('micrositeurl', {
                      initialValue: micrositeurl,
                    })(
                      <div>
                        <span className="copy-info">{micrositeurl}</span>
                        <Button type="default" htmlType="button">
                          <Copy text={micrositeurl} onCopy={this.handleCopySuccess}>
                            <div
                              data-clipboard-text="copyValue"
                              onClick={() => message.success('复制成功')}
                            >
                              复制地址
                            </div>
                          </Copy>
                        </Button>
                      </div>
                    )}
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Form.Item colon {...formItemLayout} label="二维码样式" className="qr-code">
                    {getFieldDecorator('iscustom', {
                      initialValue: iscustom,
                    })(
                      <>
                        <Radio.Group
                          onChange={e => this.handleRadioChange(e, 'iscustom')}
                          value={iscustom}
                        >
                          {orgType === 'county' ? null : (
                            <Radio style={radioStyle} value={0}>
                              默认二维码
                            </Radio>
                          )}
                          <Radio style={radioStyle} value={1}>
                            自定义
                          </Radio>
                        </Radio.Group>
                        {iscustom === 1 && (
                          <ImgUpload callback={this.handleUploadCallback} usercode={usercode} />
                        )}
                        <div style={{ color: 'rgba(0,0,0,.45)', marginTop: -12 }}>
                          说明: 可自定义设置需要在文章中插入的常用二维码
                        </div>
                      </>
                    )}
                  </Form.Item>
                </Col>
              </Row>
              {!eduAppCode[getAppCode()] && orgType === 'county' && (
                <>
                  <Row className="second">
                    <Col span={24}>
                      <Form.Item
                        colon={!1}
                        {...formItemLayout}
                        label="手机端全区资讯"
                        className="basic-info"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24}>
                      <Form.Item {...formItemLayout} className="approval" label="全区资讯展示">
                        {getFieldDecorator('news', {
                          initialValue: defaultArr,
                        })(
                          <Checkbox.Group
                            options={[
                              { label: '当前组织展示', value: '1' },
                              { label: '直属学校展示', value: '2' },
                            ]}
                          />
                        )}
                      </Form.Item>
                    </Col>
                  </Row>
                </>
              )}
              <Row className="second">
                <Col span={24}>
                  <Form.Item
                    colon={!1}
                    {...formItemLayout}
                    label="审批设置"
                    className="basic-info"
                  />
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Form.Item {...formItemLayout} className="approval" label="留言是否需要审批">
                    {getFieldDecorator('isAudit', {
                      initialValue: isAudit,
                    })(
                      <>
                        <Radio.Group
                          onChange={e => this.handleRadioChange(e, 'isAudit')}
                          value={isAudit}
                        >
                          <Radio value={1}>是</Radio>
                          <Radio value={0}>否</Radio>
                        </Radio.Group>
                        <div style={{ color: 'rgba(0,0,0,.45)', marginTop: -12 }}>
                          说明:
                          开启后，所有的文章留言需要经过管理员审核，审核人员可至资讯管理-留言记录页面筛选留言
                        </div>
                      </>
                    )}
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Form.Item {...formItemLayout} className="approval" label="发布资讯是否需要审批">
                    {getFieldDecorator('pushIsAudit', {
                      initialValue: pushIsAudit,
                    })(
                      <>
                        <Radio.Group
                          onChange={e => this.handleRadioChange(e, 'pushIsAudit')}
                          value={pushIsAudit}
                        >
                          <Radio value={1}>是</Radio>
                          <Radio value={0}>否</Radio>
                        </Radio.Group>
                        <div style={{ color: 'rgba(0,0,0,.45)', marginTop: -12 }}>
                          说明: 仅对设置后的内容生效
                        </div>
                      </>
                    )}
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Spin>
        </div>
      </Container>
    );
  }
}

export default Form.create()(WebSiteSetUp);
